import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import theme from 'styles/theme';

import Logo from 'assets/logo@2x.png';

const Header = styled.header`
  background: ${theme.B400};
  font-size: 0;
  padding: 15px 25px;
  text-align: center;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 1;

  .Header__logo {
    width: 50px;
    height: auto;
    animation-duration: 0.85s;
    animation-fill-mode: both;

    &:hover {
      animation-name: rubberBand;
    }
  }
`;

export default () => (
  <Header>
    <Link to="/">
      <img className="Header__logo" src={Logo} alt="Chris Tieman" />
    </Link>
  </Header>
);



// WEBPACK FOOTER //
// ./src/components/HeaderCompact.js